import { styled } from "@mui/material";

export const StyledSpecificDatePickerButtonValue = styled("span")`
  ${(props) => props.theme.wsc.typography.body1bold};
  margin-left: ${(props) => props.theme.wsc.spacing[0]};
`;
